import { AuthActions, AuthActionType, AuthStateType } from './auth.types';

export const authReducer = (state: AuthStateType, action: AuthActions) => {
  switch (action.type) {
    case AuthActionType.Login:
      return action.payload;

    case AuthActionType.Logout:
      return {
        token: null,
        isExpert: false,
        isFederal: false,
        isRepresentative: false,
        isAdmin: false,
        id: 0,
        isPovs: false,
        isNms: false,
        isSuperFederal: false,
      };
  }
};
